import script from "./HomeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeCard.vue?vue&type=script&setup=true&lang=js"

import "./HomeCard.vue?vue&type=style&index=0&id=4875afd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4875afd2"]])

export default __exports__